export default __webpack_public_path__ + "static/media/no-campaigns.d6a38125.svg";